import Ajax from '../../../../util/ajax';
export function zigbeeStep(nid, eid, payload) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch, true);
        const url = '/zigbee/' + nid + '/ep/' + eid + '/cluster/8/command/step';
        const value = {
            'mode': payload.mode,
            'size': payload.size,
            'transition time': payload.transitionTime,
            'execute if off': payload.executeIfOff
        };
        ajax.post(url, value);
    };
}
